<template>
<section>
	<simplert useRadius=true
	          useIcon=true
	          ref="simplert">
	</simplert>
	<div class="count-wrap">
		<div class="count-inner">
			<div class="count-text">摄入总热量</div>
			<countTo
				class="count-num" 
				:separator='theseparator' 
				:startVal='startVal' 
				:endVal='endVal' 
				:duration='2000'
			>
			</countTo>
			<div class="count-text">卡路里</div>
		</div>
	</div>
	<div class="chose-wrap">
		<h3>请选择体重与运动</h3>
		<ul>
			<li @click="selectWeight()">
				<div class="icon-weight">您的体重</div>
				<div class="icon-arrow-right">
					<span v-if="defaultWeight">{{defaultWeight}}kg</span>
				</div>
			</li>
			<li @click="selectMotion()">
				<div class="icon-motion">选择运动</div>
				<div class="icon-arrow-right motion">{{defaultMotion}}</div>
			</li>
		</ul>
	</div>

	<div class="calculate-link" @click="goresult()">计算运动方案时长</div>

</section>
</template>

<script>
  import countTo from 'vue-count-to'
  import Picker from 'better-picker'
  import Simplert from 'vue2-simplert'
  export default {
    components: { countTo ,Simplert},
    computed : {
      endVal () {
        var phflist = this.$store.state.phfoodlist
        var lens = phflist.length
        var result = 0
        for(var i = 0; i < lens; i++){
            result += phflist[i].foodWeight * phflist[i].foodUseable / 100 * (phflist[i].foodCalorie / 100)
        }
        result = Math.round(result)
        return result
      },
      dataWeight () {
        return this.$store.state.dataWeight
      }
    },
    data () {
      return {
        startVal: 0,
        theseparator:'',
        defaultWeight:0,
        defaultMotion:'',
        foodmet:0,
        sport_cover:'',
        dataMotion:[],
        title:'热量结果'
      }
    },
    head: {
      title: function () {
        return {
          inner: this.title,
          separator: ' ', 
              complement: ' '
        }
      }
    },
    created(){
    	// get motion type
    	this.axios.get(apiurl_motion_type).then((response) => {
    		var data_motion_arr = []
          	var len = response.data.length
          	for(var i = 0; i<len;i++){
          		data_motion_arr[i] = {
          			text:response.data[i].title.rendered,
          			value:response.data[i].id,
          			cover:sport_thumb_api + response.data[i].id + '.jpg',
          			foodmet:response.data[i].meta_box.sport_type_met
          		}
          	}
          	this.dataMotion = data_motion_arr
    	})
    	// end get motion type
    },
    methods:{
    	selectWeight(){
    		// picker weight
    		var picker1 = new Picker({
				data: [this.dataWeight],
				selectedIndex: [0],
				title: '选择体重'
			});
			var _that = this
			picker1.on('picker.select', function (selectedVal, selectedIndex) {
				_that.defaultWeight = _that.dataWeight[selectedIndex[0]].value
        _that.removePicker()
			})
      picker1.on('picker.cancel',function(){
          _that.removePicker()
      })
			picker1.show()
    		// end picker weight
    	},
    	selectMotion(){
    		// picker motion
    		var picker2 = new Picker({
				data: [this.dataMotion],
				selectedIndex: [0],
				title: '选择运动'
			});
			var _that = this
			picker2.on('picker.select', function (selectedVal, selectedIndex) {
				_that.defaultMotion = _that.dataMotion[selectedIndex[0]].text
				_that.foodmet = _that.dataMotion[selectedIndex[0]].foodmet
                _that.sport_cover = _that.dataMotion[selectedIndex[0]].cover
                _that.removePicker()
			})
      picker2.on('picker.cancel',function(){
          _that.removePicker()
      })
			picker2.show()
    		// end picker motion
    	},
    	goresult(){
    		if(!this.defaultWeight){
    			let obj = {
				    message: '请选择体重',
				    type: 'error',
				    customCloseBtnText:'确定'
				}
				this.$refs.simplert.openSimplert(obj)
				return false
    		}
    		if(!this.foodmet){
    			let obj = {
  				    message: '请选择运动',
  				    type: 'error',
  				    customCloseBtnText:'确定'
  				}
  				this.$refs.simplert.openSimplert(obj)
  				return false
    		}
    		var result
    		result = this.endVal / (this.foodmet * this.defaultWeight / 60)
    		this.$router.replace({ 
            path: '/result', 
            query: { 
                totaltime:Math.round(result),
                totalenergy:this.endVal,
                sportcover:this.sport_cover,
                thetitle:this.defaultMotion
            }
        });
    	}
    }
  }
</script>


// WEBPACK FOOTER //
// chosemotion.vue?46c4db67